const CONNECTOR_COMPATIBILITY = {
  xlr:              { xlr_combo: { level: "ok" },
                      quarter_inch_trs: { level: "info", message: "Different connectors, use a TRS to XLR cable", suggestion: "Select a TRS to XLR cable" },
                      quarter_inch_ts: { level: "info", message: "Different connectors, use a TS to XLR cable", suggestion: "Select a TS to XLR cable" },
                      rca: { level: "info", message: "Different connectors, use an RCA to XLR cable", suggestion: "Select an RCA to XLR cable" } },
  quarter_inch_ts:  { xlr_combo: { level: "ok" },
                      quarter_inch_trs: { level: "info", message: "TS connection loses balanced/stereo signal" },
                      rca: { level: "info", message: "Different connectors, use a TS to RCA cable", suggestion: "Select a TS to RCA cable" } },
  quarter_inch_trs: { xlr_combo: { level: "ok" },
                      quarter_inch_ts: { level: "info", message: "TS connection loses balanced/stereo signal" },
                      rca: { level: "info", message: "Different connectors, use a TRS to RCA cable", suggestion: "Select a TRS to RCA cable" } },
  mini_xlr_3pin:    { xlr: { level: "warn", message: "Mini-XLR 3-pin to XLR adapter needed", suggestion: "Add a Mini-XLR 3-pin to XLR adapter to the cable chain" },
                      mini_xlr_4pin: { level: "error", message: "3-pin and 4-pin mini-XLR are not compatible" } },
  mini_xlr_4pin:    { xlr: { level: "warn", message: "Mini-XLR 4-pin to XLR adapter needed", suggestion: "Add a Mini-XLR 4-pin to XLR adapter to the cable chain" },
                      mini_xlr_3pin: { level: "error", message: "3-pin and 4-pin mini-XLR are not compatible" } },
  eighth_inch_trs:  { quarter_inch_trs: { level: "warn", message: '1/8" to 1/4" adapter needed', suggestion: 'Add a 1/8" TRS to 1/4" TRS adapter to the cable chain' },
                      eighth_inch_trrs: { level: "info", message: "TRS in TRRS jack loses mic channel" } },
  eighth_inch_trrs: { quarter_inch_trs: { level: "warn", message: '1/8" to 1/4" adapter needed', suggestion: 'Add a 1/8" TRRS to 1/4" TRS adapter to the cable chain' },
                      eighth_inch_trs: { level: "info", message: "TRRS in TRS jack loses mic channel" } },
  usb_a:            { usb_b: { level: "warn", message: "USB adapter needed", suggestion: "Use a USB-A to USB-B cable directly" },
                      usb_c: { level: "warn", message: "USB adapter needed", suggestion: "Use a USB-A to USB-C cable directly" } },
  usb_b:            { usb_a: { level: "warn", message: "USB adapter needed", suggestion: "Use a USB-A to USB-B cable directly" },
                      usb_c: { level: "warn", message: "USB adapter needed", suggestion: "Add a USB adapter to the cable chain" } },
  usb_c:            { usb_a: { level: "warn", message: "USB adapter needed", suggestion: "Use a USB-A to USB-C cable directly" },
                      usb_b: { level: "warn", message: "USB adapter needed", suggestion: "Add a USB adapter to the cable chain" } },
  ac_outlet:        { ac_cable: { level: "ok" } },
  toslink:          { rca: { level: "error", message: "Mismatched connectors: Toslink (optical) and RCA (coaxial)" } },
  ethernet:         { ultranet: { level: "ok" },
                      ethercon: { level: "ok" } },
  ultranet:         { ethernet: { level: "ok" },
                      ethercon: { level: "ok" } },
  ethercon:         { ethernet: { level: "error", message: "EtherCon plug won't fit a standard RJ45 jack", suggestion: "Use a regular Ethernet cable instead" },
                      ultranet: { level: "error", message: "EtherCon plug won't fit a standard RJ45 jack", suggestion: "Use a regular Ethernet cable instead" } },
  db25:             { xlr: { level: "info", message: "Different connectors, use a DB-25 to XLR snake", suggestion: "Select a DB-25 to XLR snake cable" },
                      quarter_inch_trs: { level: "info", message: "Different connectors, use a DB-25 to TRS snake", suggestion: "Select a DB-25 to TRS snake cable" } },
};

const SIGNAL_LEVEL_COMPATIBILITY = {
  mic:        { mic_line: { level: "ok" },
                instrument: { level: "warn", message: "Too quiet, essentially non-functional", suggestion: "Use a preamp to boost the signal" },
                line: { level: "warn", message: "Too quiet, essentially non-functional", suggestion: "Use a preamp to boost the signal" },
                speaker: { level: "error", message: "Won't drive speaker" } },
  line:       { mic_line: { level: "ok" },
                instrument: { level: "info", message: "Signal too hot", suggestion: "Use a pad or reduce the gain" },
                mic: { level: "error", message: "Way too hot for mic preamp", suggestion: "Use a DI box or pad to attenuate the signal" },
                speaker: { level: "error", message: "Won't drive speaker" } },
  mic_line:   { mic: { level: "ok" },
                line: { level: "ok" },
                instrument: { level: "info", message: "Signal too hot", suggestion: "Use a pad or reduce the gain" },
                speaker: { level: "error", message: "Won't drive speaker" } },
  instrument: { line: { level: "info", message: "Signal too quiet", suggestion: "Use a gain boost or preamp to boost the signal" },
                mic_line: { level: "info", message: "Signal too quiet", suggestion: "Use a gain boost or preamp to boost the signal" },
                mic: { level: "warn", message: "Could overdrive mic preamp", suggestion: "Use a DI box between these devices" },
                speaker: { level: "error", message: "Won't drive speaker" } },
  speaker:    { mic: { level: "error", message: "Dangerous power levels", suggestion: "Never connect a speaker output directly to a mic input" },
                line: { level: "error", message: "Dangerous power levels", suggestion: "Never connect a speaker output directly to a line input" },
                instrument: { level: "error", message: "Dangerous power levels", suggestion: "Never connect a speaker output directly to an instrument input" },
                mic_line: { level: "error", message: "Dangerous power levels", suggestion: "Never connect a speaker output directly to a mic/line input" } },
};

export function lookupConnectorCompat(from, to) {
  if (from === to) return { level: "ok" };
  const forward = CONNECTOR_COMPATIBILITY[from]?.[to];
  if (forward) return forward;
  const reverse = CONNECTOR_COMPATIBILITY[to]?.[from];
  if (reverse) return reverse;
  return { level: "error", message: "Mismatched connectors" };
}

function signalTypesOverlap(portA, portB) {
  const typesA = portA.signal_types || [portA.signal_type];
  const typesB = portB.signal_types || [portB.signal_type];
  return typesA.some((t) => typesB.includes(t));
}

function lookupSignalLevelCompat(from, to) {
  if (from === to) return { level: "ok" };
  const result = SIGNAL_LEVEL_COMPATIBILITY[from]?.[to];
  if (result) return result;
  return { level: "error", message: `Signal level mismatch: ${from} to ${to}` };
}

export function checkBoundaryCompatibility(boundary, port) {
  const notes = [];
  if (!boundary || !port) return { hasErrors: false, hasInfos: false, notes };

  const isAudio = (boundary.signal_type || "audio") === "audio";

  if (boundary.connector && port.connector) {
    const connResult = lookupConnectorCompat(boundary.connector, port.connector);
    if (connResult.level !== "ok") {
      const note = { message: connResult.message, severity: connResult.level };
      if (connResult.suggestion) note.suggestion = connResult.suggestion;
      notes.push(note);
    }
  }

  if (boundary.signal_type && port.signal_type && boundary.signal_type !== port.signal_type) {
    if (!signalTypesOverlap(boundary, port)) {
      notes.push({
        message: `Signal type mismatch: ${boundary.signal_type} to ${port.signal_type}`,
        severity: "error",
      });
    }
  }

  if (isAudio && boundary.signal_level && port.signal_level) {
    const isOutput = boundary.direction === "output";
    const fromLevel = isOutput ? port.signal_level : boundary.signal_level;
    const toLevel = isOutput ? boundary.signal_level : port.signal_level;
    const levelResult = lookupSignalLevelCompat(fromLevel, toLevel);
    if (levelResult.level !== "ok") {
      const note = { message: levelResult.message, severity: levelResult.level };
      if (levelResult.suggestion) note.suggestion = levelResult.suggestion;
      notes.push(note);
    }
  }

  if (isAudio && boundary.phantom_power && port.phantom_power) {
    if (boundary.direction === "input") {
      if (boundary.phantom_power === "required" && port.phantom_power === "not_allowed") {
        notes.push({
          message: "Phantom power conflict: source requires phantom power but device does not allow it",
          severity: "error",
        });
      }
    } else {
      if (port.provides_phantom_power === "always_on" && boundary.phantom_power === "not_allowed") {
        notes.push({
          message: "Phantom power conflict: device always provides phantom power and it cannot be turned off",
          severity: "error",
        });
      } else if (port.provides_phantom_power === "switchable" && boundary.phantom_power === "not_allowed") {
        notes.push({
          message: "Phantom power warning: device can provide phantom power, make sure it is turned off",
          severity: "info",
        });
      }
    }
  }

  const hasErrors = notes.some((n) => n.severity === "error");
  const hasWarns = notes.some((n) => n.severity === "warn");
  const hasInfos = notes.some((n) => n.severity === "info");
  return { hasErrors, hasWarns, hasInfos, notes };
}

export function checkSignalFanout(edges) {
  const issues = [];
  const outputGroups = new Map();

  for (const edge of edges) {
    if (edge.data?.connectionType === "power") continue;
    const key = `${edge.source}:${edge.sourceHandle}`;
    if (!outputGroups.has(key)) outputGroups.set(key, []);
    outputGroups.get(key).push(edge);
  }

  for (const [, group] of outputGroups) {
    if (group.length <= 1) continue;
    const hasYCable = group.some((e) => {
      const chain = e.data?.cableChain || [];
      return chain.some((entry) => entry.cable?.cable_type === "y_cable");
    });
    if (!hasYCable) {
      const note = {
        message: `Output drives ${group.length} inputs without a splitter`,
        severity: "warn",
        suggestion: "Use a Y-cable or splitter for this connection",
      };
      for (const edge of group) {
        issues.push({ edgeId: edge.id, notes: [note] });
      }
    }
  }
  return issues;
}

function connectorsMatch(cableConn, portConn) {
  if (cableConn === portConn) return true;
  // XLR plug fits XLR combo jack (and vice versa)
  if (portConn === "xlr_combo" && (cableConn === "xlr" || cableConn === "quarter_inch_ts" || cableConn === "quarter_inch_trs")) return true;
  if (cableConn === "xlr_combo" && (portConn === "xlr" || portConn === "quarter_inch_ts" || portConn === "quarter_inch_trs")) return true;
  return false;
}

function cableBridgesConnectors(cableChain, fromConnector, toConnector) {
  if (!cableChain || cableChain.length === 0) return false;
  const first = cableChain[0]?.cable;
  const last = cableChain[cableChain.length - 1]?.cable;
  return connectorsMatch(first?.input_connector, fromConnector) && connectorsMatch(last?.output_connector, toConnector);
}

export function checkCompatibility(fromPort, toPort, { fromDevice, toDevice, cableChain } = {}) {
  const notes = [];

  const fromWireless = fromPort.connector === "wireless";
  const toWireless = toPort.connector === "wireless";

  if (fromWireless || toWireless) {
    if (fromWireless !== toWireless) {
      notes.push({ message: "Cannot connect wireless and wired ports", severity: "error" });
    } else {
      const fromSystem = fromDevice?.wireless_system;
      const toSystem = toDevice?.wireless_system;
      if (fromSystem && toSystem && fromSystem !== toSystem) {
        notes.push({
          message: `Incompatible wireless systems: ${fromSystem.replace(/_/g, " ")} and ${toSystem.replace(/_/g, " ")}`,
          severity: "error",
        });
      }
      const isWirelessAudio = fromPort.signal_type === "audio" || fromPort.signal_type === "usb_audio";
      if (isWirelessAudio && fromPort.signal_level && toPort.signal_level) {
        const levelResult = lookupSignalLevelCompat(fromPort.signal_level, toPort.signal_level);
        if (levelResult.level !== "ok") {
          const note = { message: levelResult.message, severity: levelResult.level };
          if (levelResult.suggestion) note.suggestion = levelResult.suggestion;
          notes.push(note);
        }
      }
    }
    const hasErrors = notes.some((n) => n.severity === "error");
    const hasWarns = notes.some((n) => n.severity === "warn");
    const hasInfos = notes.some((n) => n.severity === "info");
    return { compatible: !hasErrors, hasErrors, hasWarns, hasInfos, notes };
  }

  if (fromPort.signal_type !== toPort.signal_type) {
    if (!signalTypesOverlap(fromPort, toPort)) {
      notes.push({
        message: `Signal type mismatch: ${fromPort.signal_type} output to ${toPort.signal_type} input`,
        severity: "error",
      });
    }
  }

  if (fromPort.connector && toPort.connector) {
    const bridged = cableBridgesConnectors(cableChain, fromPort.connector, toPort.connector);
    if (!bridged) {
      const connResult = lookupConnectorCompat(fromPort.connector, toPort.connector);
      if (connResult.level !== "ok") {
        const note = { message: connResult.message, severity: connResult.level };
        if (connResult.suggestion) note.suggestion = connResult.suggestion;
        notes.push(note);
      }
    }
  }

  const isAudioConnection = fromPort.signal_type === "audio" || fromPort.signal_type === "usb_audio";
  if (isAudioConnection && fromPort.signal_level && toPort.signal_level) {
    const levelResult = lookupSignalLevelCompat(fromPort.signal_level, toPort.signal_level);
    if (levelResult.level !== "ok") {
      const note = { message: levelResult.message, severity: levelResult.level };
      if (levelResult.suggestion) note.suggestion = levelResult.suggestion;
      notes.push(note);
    }
  }

  if (isAudioConnection && fromPort.provides_phantom_power === "always_on" && toPort.phantom_power === "not_allowed") {
    notes.push({
      message: "Phantom power conflict: source always provides phantom power and it cannot be turned off",
      severity: "error",
    });
  }

  if (isAudioConnection && fromPort.provides_phantom_power === "switchable" && toPort.phantom_power === "not_allowed") {
    notes.push({
      message: "Phantom power warning: source can provide phantom power, make sure it is turned off",
      severity: "info",
    });
  }

  if (isAudioConnection && fromPort.provides_phantom_power === "not_available" && toPort.phantom_power === "required") {
    notes.push({
      message: "No phantom power: device requires phantom power to operate",
      severity: "error",
    });
  }

  if (isAudioConnection && fromPort.provides_phantom_power === "switchable" && toPort.phantom_power === "required") {
    notes.push({
      message: "Phantom power required: make sure phantom power is enabled on the source",
      severity: "info",
    });
  }

  // Reverse phantom: mic output requires phantom, check if preamp input provides it
  if (isAudioConnection && fromPort.phantom_power === "required" && toPort.provides_phantom_power === "not_available") {
    notes.push({
      message: "No phantom power: device requires phantom power to operate",
      severity: "error",
    });
  }

  if (isAudioConnection && fromPort.phantom_power === "required" && toPort.provides_phantom_power === "switchable") {
    notes.push({
      message: "Phantom power required: make sure phantom power is enabled",
      severity: "info",
    });
  }

  const hasErrors = notes.some((n) => n.severity === "error");
  const hasWarns = notes.some((n) => n.severity === "warn");
  const hasInfos = notes.some((n) => n.severity === "info");

  return {
    compatible: !hasErrors,
    hasErrors,
    hasWarns,
    hasInfos,
    notes,
  };
}
